<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <p class="title">
                                BILLING: Update Income Summary
                                <v-btn @click="dialog = !dialog" icon>
                                    <v-icon med>help</v-icon>
                                </v-btn>
                            </p>
                            <div v-if="dialog">
                                <ol>
                                    <li>Login to Quickbooks</li>
                                    <li>Go to "Reports > All Reports > Review Sales > Income by Customer Summary"</li>
                                    <li>
                                        VERY IMPORTANT: select a date range that captures the last 30 days and is not
                                        more than 35 days.
                                    </li>
                                    <li>
                                        Once the report is loaded, click the "Export" button below and select
                                        "Excel (XLS)". The report is now saved in your downloads folder.
                                    </li>
                                    <li>
                                        Click the form box below to select a file to upload, or drag the file to the box
                                        from your local folder.
                                    </li>
                                    <li>
                                        The submit button will now be active. Confirm you selected the correct file by
                                        reviewing the filename in the form box. Click the submit button. <br>
                                    </li>
                                    <li>
                                        Once the loading is complete, the DB Response section will display the results as
                                        written to the database.
                                    </li>
                                </ol>
                            </div>
<!--                            <FileUploader endpoint="https://belit.conflabs.com/api/v1/resource/billing/uploadIncomeSummary"-->

                          <FileUploader endpoint="https://wa.belit.conflabs-apis.com/api/v1/resource/billing/uploadIncomeSummary"
                                            @tattle="uploadIncomeResponse"
                                            @resetter="resetIncome"
                                            :key="incomeKey"
                            ></FileUploader>
                        </v-flex>
                        <v-flex xs12>
                            <br>
                            <p class="title">DB Response:</p>
                            <p class="subtitle" v-if="!incomeResponse"><i>Waiting for User...</i></p>
                            <div v-else>
                                <v-layout row>
                                    <v-flex xs2><p class="body-2">Name</p></v-flex>
                                    <v-flex xs2><p class="body-2">Income</p></v-flex>
                                    <v-flex xs2><p class="body-2">Expense</p></v-flex>
                                    <v-flex xs2><p class="body-2">Total</p></v-flex>
                                    <v-flex xs2><p class="body-2">Date</p></v-flex>
                                    <v-spacer></v-spacer>
                                </v-layout>
                                <v-layout v-for="item in success" :key="item.customer_uuid">
                                    <v-flex xs2><p class="body-1">{{ item.qbo_name }}</p></v-flex>
                                    <v-flex xs2><p class="body-1">{{ item.income }}</p></v-flex>
                                    <v-flex xs2><p class="body-1">{{ item.expenses }}</p></v-flex>
                                    <v-flex xs2><p class="body-1">{{ item.net_income }}</p></v-flex>
                                    <v-flex xs2><p class="body-1">{{ item.date }}</p></v-flex>
                                    <v-spacer></v-spacer>
                                </v-layout>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "income-upload",
        components: {
            FileUploader: () => import("../components/general/FileUploader"),
        },
        data() {
            return {
                incomeResponse: "",
                incomeKey: 0,
                success: [],
                fail: [],
                dialog: false
            }
        },
        methods: {
            uploadIncomeResponse(value) {
                this.incomeResponse = value
                this.success = value.success
                this.fail = value.fail
            },
            resetIncome() {
                this.incomeKey += 1;
                this.incomeResponse = ""
            },

        }
    }
</script>

<style scoped>

</style>
